import { type Region, locations } from '../../../../seo-locations/src'

export type City = {
  readonly name: string
  readonly lat: number
  readonly lng: number
  readonly url?: string
}

type StateNameToStateObj = Record<
  string,
  {
    readonly cities: readonly City[]
    readonly dynamicCities: readonly City[]
    readonly state_id: string
    readonly lat: number
    readonly lng: number
    readonly region: Region
  }
>

export const stateDictionary = <StateNameToStateObj>locations

// For the Benefits component CTFL entry only. If we add more region content we have to change this code
export const regionContentId = {
  midAtlantic: '615atyBEGWhfQSdvLUjIQq',
  midWest: '4Uu0HQDsizyBizYn23vASW',
  mountain: '6TZ9DPGMMfJ1IOsnU6rpv9',
  newEngland: '6ZE9ykO3UYWm1VOJqyydUM',
  southEast: '6icr7r9QSawXaygd88K0rU',
  southwest: '48ypqOgODM8kVW92VRdYFc'
}

export const locationDisplayName = (
  state: string,
  stateId?: string,
  city?: string
) => {
  const cityWithStateId = stateId ? `${city}, ${stateId}` : city
  // If city is defined, so is stateId. Hence cityWithStateId is a string and here we apply the String constructor to it to avoid TS errors
  return city && city !== '' ? String(cityWithStateId) : state
}

export const bestSystemsRegionalData = {
  description: {
    midAtlantic:
      'Advanced Security. 24/7 whole home protection. Our agents are ready to dispatch help in any emergency in {{location}}. Sensors that protect every room, window and door. HD security cameras for clear views inside and out, daytime or night. Hazard sensors that detect fires, floods, and other threats to your home, and powerful sirens that can instantly stop intruders in their tracks. Interactive guidance to set the system up yourself or highly trained technicians to do it for you.',
    newEngland:
      'We offer sensors for every room, window and door. HD security cameras for inside and out. Cameras that know the difference between a person and a rustling pile of leaves, perfect for fall in {{location}}. Hazard sensors that detect fires, floods, low temperatures in the winter and other threats to your home, and powerful sirens that can instantly stop intruders in their tracks. All powered by live, 24/7 professional monitoring agents — ready to send help fast.',
    midWest:
      'We offer sensors for every room, window and door. HD security cameras for inside and out. Smarter ways to detect motion. Temperature sensors ready to alert you of dangerously low temperatures during the cold {{location}} winters. Hazard sensors that detect fires, floods, and other threats to your home, and powerful sirens that can instantly stop intruders in their tracks. All powered by live, 24/7 professional monitoring agents — ready to send help fast.',
    southEast:
      'We offer sensors for every room, window and door. HD security cameras for inside and out. Smarter ways to detect motion. Water sensors that can alert you of flooding, perfect for those {{location}} summers. Hazard sensors that detect fires, floods, and other threats to your home, and powerful sirens that can instantly stop intruders in their tracks. All powered by live, 24/7 professional monitoring agents — ready to send help fast.',
    mountain:
      'We offer sensors for every room, window and door. HD security cameras for inside and out. Great for capturing evidence or seeing a native animal or two in {{location}}. Hazard sensors that detect fires, floods, and other threats to your home, and powerful sirens that can instantly stop intruders in their tracks. All powered by live, 24/7 professional monitoring agents — ready to send help fast.',
    southwest:
      'Advanced Security. 24/7 whole home protection. Our agents are ready to dispatch help in any emergency. Sensors that protect every room, window and door. HD security cameras for clear views of {{location}}, inside and out, daytime or night. Hazard sensors that detect fires, floods, and other threats to your home, and powerful sirens that can instantly stop intruders in their tracks. Interactive guidance to set the system up yourself or highly trained technicians to do it for you. '
  },
  title: 'Best Home Security Systems in {{location}}'
}
